module.exports = "/images/vendor/desiigner-svg/svg/ui/gallery.svg?f9d87d7c42b468bff920ade1bf38aeb5";